// extracted by mini-css-extract-plugin
export default {"detailsViewContainer":"pUeDhnVZanlD_Er1asCw","preloaderContainer":"awY8AlmtoFjOv8Mr65Mo","preloader":"nMuasW4L0VUnyh7dXyJO"};